import { useUITheme } from "@/app/hooks/ui_hooks/useUITheme";
import clsx from "clsx";
import { INoREcordFound } from "../interface";

const NoDataFoundComponent: React.FC<INoREcordFound> = ({
  message,
  description,
  imageURL,
  className,
  InputClassName,
}) => {
  const { theme } = useUITheme();
  return (
    <div className={clsx("my-10 flex flex-col items-center justify-center", InputClassName)}>
      {imageURL && (
        <img
          src={imageURL}
          alt="no-data"
          className={clsx(
            "w-[100px] md:w-[250px] xl:w-[240px] 2xl:w-[300px]",
            className,
            theme !== "VETIC" && "invert",
          )}
        />
      )}
      <p className="pt-3 text-center text-[10px] font-semibold text-gray-700 sm:text-xs 2xl:text-sm">{message}</p>
      {description && (
        <p className="mt-1 text-center text-[11px] font-normal text-gray-500 md:text-xs">{description}</p>
      )}
    </div>
  );
};

export default NoDataFoundComponent;
